import { StyleSheet } from 'react-native';
import { neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  scrollView: {
    paddingBottom: 24,
    paddingHorizontal: 16,
  },
  contentContainer: {
    gap: 24,
  },
  text: {
    fontSize: 12,
    fontWeight: 700,
    marginBottom: 8,
  },
  input: {
    width: '100%',
    height: 90,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: neutrals.neutralGrays.dust,
    paddingVertical: 8,
    paddingHorizontal: 16,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  inputText: {
    flex: 1,
    fontSize: 14,
    lineHeight: 24,
    fontWeight: 400,
    color: neutrals.neutralGrays.graphite,
  },
  button: {
    paddingHorizontal: 8,
  },
  containerToolOptions: {
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: 2.5,
    rowGap: 12,
  },
  counter: {
    position: 'absolute',
    bottom: 5,
    right: 10,
    fontSize: 12,
    color: neutrals.neutralGrays.ash,
  },
});
